export const imageBlockHeader = {
  awards: 'Award-winning portfolio tracking',
  registries: 'Track shares from popular share registries',
  featured: 'Featured in',
};
